import script from "./SwitchSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./SwitchSection.vue?vue&type=script&lang=ts&setup=true"

import "./SwitchSection.vue?vue&type=style&index=0&id=77341f96&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77341f96"]])

export default __exports__